import * as Yup from "yup";

export const ResponseValidator = async ({ isError, message, serverResponse }) => {
  const validator = Yup.object().shape({
    isError: Yup.bool(),
    message: Yup.string(),
    serverResponse: Yup.object().shape({
      code: Yup.number(),
      message: Yup.string(),
    }),
  });

  try {
    return await validator.isValid({
      isError,
      message,
      serverResponse,
    });
  } catch (err) {
    console.log(err);
    return false;
  }
};